import axios from "./axiosConfig";

/**
 * Capa de servicios HTTP del modulo CRM.
 * Sigue el patron del repo: objeto plano con metodos que retornan
 * promesas de axios. El backend responde { success, data, pagination }.
 */
const crmService = {
  // ===== Dashboard / metricas =====
  getKpis() {
    return axios.get("/crm/kpis");
  },
  getGoals() {
    return axios.get("/crm/goals");
  },
  updateGoals(data) {
    return axios.put("/crm/goals", data);
  },
  getPending() {
    return axios.get("/crm/pending");
  },
  getCompetition(params = {}) {
    return axios.get("/crm/competition", { params });
  },
  getActivityFeed(params = {}) {
    return axios.get("/crm/activity-feed", { params });
  },
  getSalesPerformance(params = {}) {
    return axios.get("/crm/sales-performance", { params });
  },

  // ===== Leads =====
  getLeads(params = {}) {
    return axios.get("/crm/leads", { params });
  },
  getLead(id) {
    return axios.get(`/crm/leads/${id}`);
  },
  createLead(data) {
    return axios.post("/crm/leads", data);
  },
  updateLead(id, data) {
    return axios.put(`/crm/leads/${id}`, data);
  },
  deleteLead(id) {
    return axios.delete(`/crm/leads/${id}`);
  },

  // ===== Operaciones =====
  assignLead(id, assignedTo) {
    return axios.patch(`/crm/leads/${id}/assign`, { assignedTo });
  },
  changeStatus(id, status, reason) {
    return axios.patch(`/crm/leads/${id}/status`, { status, reason });
  },
  closeLead(id, data) {
    return axios.post(`/crm/leads/${id}/close`, data);
  },
  convertLead(id) {
    return axios.post(`/crm/leads/${id}/convert`);
  },

  // ===== Historial =====
  getTimeline(id) {
    return axios.get(`/crm/leads/${id}/timeline`);
  },
  getActivities(id) {
    return axios.get(`/crm/leads/${id}/activities`);
  },
  getStatusHistory(id) {
    return axios.get(`/crm/leads/${id}/status-history`);
  },

  // ===== Seguimientos =====
  getFollowUps(id) {
    return axios.get(`/crm/leads/${id}/followups`);
  },
  addFollowUp(id, data) {
    return axios.post(`/crm/leads/${id}/followups`, data);
  },
  updateFollowUp(followUpId, data) {
    return axios.put(`/crm/followups/${followUpId}`, data);
  },
  deleteFollowUp(followUpId) {
    return axios.delete(`/crm/followups/${followUpId}`);
  },

  startCall(leadId) {
    return axios.post("/crm/calls", { leadId });
  },
  saveCallNotes(id, notes) {
    return axios.patch(`/crm/calls/${id}/notes`, { notes });
  },
  endCall(id, data) {
    return axios.post(`/crm/calls/${id}/end`, data);
  },
  discardCall(id) {
    return axios.post(`/crm/calls/${id}/discard`);
  },

  // ===== Adjuntos (metadatos; binario en S3 via filesService) =====
  getAttachments(id) {
    return axios.get(`/crm/leads/${id}/attachments`);
  },
  addAttachment(id, data) {
    return axios.post(`/crm/leads/${id}/attachments`, data);
  },
  deleteAttachment(id, attachmentId) {
    return axios.delete(`/crm/leads/${id}/attachments/${attachmentId}`);
  },

  // ===== Asignador automático =====
  getAssignConfig() {
    return axios.get("/crm/assign-config");
  },
  updateAssignConfig(data) {
    return axios.put("/crm/assign-config", data);
  },
  runAutoAssign(batchSize) {
    return axios.post("/crm/assign-config/run", batchSize != null ? { batchSize } : {});
  },

  // ===== Equipo / vendedores =====
  getSellers() {
    return axios.get("/crm/sellers");
  },
  createSeller(data) {
    return axios.post("/crm/sellers", data);
  },
  updateSeller(id, data) {
    return axios.put(`/crm/sellers/${id}`, data);
  },
};

export default crmService;
